import { render, staticRenderFns } from "./TreeNote.vue?vue&type=template&id=3f8d1720&scoped=true&"
import script from "./TreeNote.vue?vue&type=script&lang=js&"
export * from "./TreeNote.vue?vue&type=script&lang=js&"
import style0 from "./TreeNote.vue?vue&type=style&index=0&id=3f8d1720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8d1720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSpacer,VTooltip})
